import { captureException } from '@sentry/react'
import type { z } from 'zod'
import axios from '@/axios-instance-node'
import { PaginatedGeoResponse } from '@/features/subgeo/types.ts'
import { parseResponseData } from '@/helpers/utils'
import type { PaginationParams, ResponseType } from '@/types.ts'

export type HttpGetGeosParams = PaginationParams & {
	geoCode?: string
	responseType: ResponseType
	type?: 'view_only'
}

export const HttpGetGeosResponse = PaginatedGeoResponse

export type HttpGetGeosResponse = z.infer<typeof HttpGetGeosResponse>

export const httpGetGeos = async (params: HttpGetGeosParams) => {
	const response = await axios.get('/v1/geo-mapping-geos', { params })
	return parseResponseData({
		responseData: response.data,
		responseShape: HttpGetGeosResponse,
		onZodError: captureException
	})
}
